import fetch from "../utils/fetch";

// 获取新闻列表
export function getNews(data) {
  return fetch({
    url: "/api/news/list",
    method: "get",
    params: data,
  });
}
//获取详情
export function getNewsDetail(data) {
  return fetch({
    url: "/api/news/newsInfo",
    method: "get",
    params: data,
  });
}
// 获取公司公告列表
export function getNotice(data) {
  return fetch({
    url: "/api/news/notice",
    method: "get",
    params: data,
  });
}
// 搜索
export function serachInfo(data) {
  return fetch({
    url: "/api/search",
    method: "get",
    params: data,
  });
}
// 招聘
export function getJob(data) {
  return fetch({
    url: "/api/job",
    method: "get",
    params: data,
  });
}
//获取员工活动
export function getEmpAct(data) {
  return fetch({
    url: "/api/employee/list",
    method: "get",
    params: data,
  });
}
//留言
export function addMsg(data) {
  return fetch({
    url: "/api/message/add",
    method: "post",
    data: data,
  });
}
//验证码
export function getCode(data) {
  return fetch({
    url: "/api/message/verifyCode",
    method: "get",
    params: data,
    responseType: "blob",
  });
}
//获取留言列表
export function getMsgList(data) {
  return fetch({
    url: "/api/message/list",
    method: "get",
    params: data,
  });
}
//获取内刊列表
export function getPaperList(data) {
  return fetch({
    url: "/api/intNewsPaper/list",
    method: "get",
    params: data,
  });
}
